import e, { memo as q, useRef as J, useCallback as K, useMemo as Q } from "react";
import { useTheme as X, useDisclosure as Y, AspectRatio as Z, Image as M, Skeleton as L, Flex as p, Text as k, Link as C } from "@chakra-ui/react";
import { ButtonLink as T } from "../../atoms/link/button-link.js";
import { getFocusIndicator as ee } from "../../../utils/accessibilityUtils.js";
import { getTypography as c, getResponsiveTypography as v } from "../../../utils/typographyUtils.js";
import { getRelAttributeAccordingToUrl as D } from "../../../utils/externalUrlChecker.js";
import { AnalyticsEventType as te } from "../../../types/analytics.enums.js";
import { Card as oe, CardMedia as re, CardContent as ne } from "../../atoms/card/card.js";
import { InfoBadge as ie } from "../../atoms/badge/info-badge/info-badge.js";
import { Modal as le } from "../modal/modal.js";
import "react-icons/md";
import { Button as me } from "../../atoms/button/button.js";
import "../../atoms/button/icon-button.js";
import "react-icons/fa";
import "@loadable/component";
import "../../atoms/button/masthead-button.js";
import "framer-motion";
import "react-icons/fi";
import "react-icons/hi";
import "react-icons/ri";
import "react-icons/io5";
import "../../atoms/button/close-button.js";
const se = q(
  ({
    variant: _,
    title: H,
    altText: w,
    cardCta1: o,
    cardCta2: r,
    cardCtaLink: m,
    cardCtaModal: n,
    cardImage: B,
    cardContent: R,
    cardBgColor: h,
    cardClickAction: u,
    badge: d,
    cardMinWidth: S = "auto",
    position: I,
    trackingFn: E
  }) => {
    const i = X(), {
      cardContentSpacing: f,
      cardContentPadding: F,
      action: t,
      linkUnderline: b,
      linkDefault: g,
      border: { actionSecondary: G },
      button: { borderWidth: N }
    } = i, V = J(), y = K(
      (l, a) => {
        l.preventDefault(), a && (E && E(te.UI_ENGAGEMENT, {
          actionType: "click",
          callToActionElement: a,
          position: I
        }), a != null && a.url && u && u(a.url));
      },
      []
    ), z = Q(() => ({
      button: D(o == null ? void 0 : o.url),
      link: D(r == null ? void 0 : r.url)
    }), [o == null ? void 0 : o.url, r == null ? void 0 : r.url]), s = ee(h), O = {
      mobile: c("cardHeadlineMobile", i),
      tablet: c("cardHeadlineTablet", i),
      desktop: c("cardHeadlineDesktop", i)
    }, U = v(
      O
    ), W = {
      mobile: c("cardBodyMobile", i),
      tablet: c("cardBodyTablet", i),
      desktop: c("cardBodyDesktop", i)
    }, $ = v(
      W
    ), { isOpen: j, onOpen: A, onClose: P } = Y(), x = `${N} solid ${G}`;
    return /* @__PURE__ */ e.createElement(
      oe,
      {
        variant: _,
        width: "inherit",
        overflow: "hidden",
        minW: S,
        ref: V
      },
      /* @__PURE__ */ e.createElement(re, null, /* @__PURE__ */ e.createElement(Z, { ratio: 16 / 9, width: "inherit", overflow: "hidden" }, /* @__PURE__ */ e.createElement(
        M,
        {
          fallback: /* @__PURE__ */ e.createElement(L, { "data-testid": "skeleton-image", w: "100%", minH: "100%" }),
          "data-testid": "feature-card-image",
          src: B,
          alt: w || "",
          loading: "lazy",
          height: "inherit"
        }
      ))),
      /* @__PURE__ */ e.createElement(ne, { p: F, background: h }, /* @__PURE__ */ e.createElement(
        p,
        {
          direction: "column",
          h: "100%",
          justifyContent: "space-between",
          rowGap: f
        },
        /* @__PURE__ */ e.createElement(p, { direction: "column", rowGap: f }, d && /* @__PURE__ */ e.createElement(p, null, /* @__PURE__ */ e.createElement(ie, { badgeClass: d.badgeClass }, d.text)), /* @__PURE__ */ e.createElement(
          k,
          {
            "data-testid": "feature-card-title",
            noOfLines: 2,
            as: "h3",
            ...U
          },
          H
        ), /* @__PURE__ */ e.createElement(k, { "data-testid": "feature-card-content", ...$ }, R)),
        /* @__PURE__ */ e.createElement(
          p,
          {
            direction: "row",
            alignItems: "center",
            columnGap: f
          },
          o && /* @__PURE__ */ e.createElement(
            T,
            {
              "data-testid": "feature-card-cta",
              _hover: { textDecoration: "none" },
              onClick: (l) => y(l, o),
              href: o.url,
              _focus: s,
              variant: "secondary",
              size: "medium",
              _focusVisible: s,
              border: x
            },
            o.text
          ),
          r && /* @__PURE__ */ e.createElement(
            T,
            {
              "data-testid": "feature-card-cta-2",
              _hover: { textDecoration: "none" },
              onClick: (l) => y(l, r),
              href: r.url,
              _focus: s,
              variant: "secondary",
              size: "medium",
              _focusVisible: s,
              border: x
            },
            r.text
          ),
          (m == null ? void 0 : m.url) && /* @__PURE__ */ e.createElement(
            C,
            {
              className: "cta-link",
              "data-testid": "feature-card-cta-link",
              _hover: {
                textDecoration: "none",
                color: t == null ? void 0 : t.primaryHover
              },
              href: m.url,
              onClick: (l) => y(l, m),
              rel: z.link,
              textDecoration: b,
              flexShrink: "0",
              color: t == null ? void 0 : t.primaryDefault,
              ...g
            },
            m.text
          ),
          n && /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
            me,
            {
              className: "cta-link",
              "data-testid": "feature-card-cta-modal",
              _hover: {
                textDecoration: "none",
                color: t == null ? void 0 : t.primaryHover,
                backgroundColor: "transparent"
              },
              _focus: s,
              onClick: A,
              _focusVisible: s,
              textDecoration: b,
              flexShrink: "0",
              p: "0",
              color: t == null ? void 0 : t.primaryDefault,
              backgroundColor: "transparent",
              ...g
            },
            n.linkText
          ), /* @__PURE__ */ e.createElement(
            le,
            {
              contentTitle: n.contentTitle,
              modalTitle: n.modalTitle,
              modalSupertext: n.modalSupertext,
              contentText: n.contentText,
              callToAction1: n.callToAction1,
              callToAction2: n.callToAction2,
              ctaClickHandler: u,
              isOpen: j,
              onClose: P,
              isFooterCentered: !0
            }
          ))
        )
      ))
    );
  }
);
se.displayName = "FeatureCard";
export {
  se as FeatureCard
};
